import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import {
  getEntityTypeAndUniqueIdFromEntityId,
  isComplexEntityType,
} from "../../../../../../../../utils/utils";

export const CustomLogTypography = ({ children, ...props }) => {
  const colors = useColors();
  return (
    <Typography
      component="span"
      variant="body2"
      color={colors.text_secondary}
      {...props}
    >
      {children}
    </Typography>
  );
};

export const EntityLink = ({ children, entityId, log }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [searchParams, setSearchParams] = useSearchParams();

  const maxNameSize = 20;
  const [entityType] = getEntityTypeAndUniqueIdFromEntityId(entityId);

  if (!children) {
    return null;
  }

  const entityNameToDisplay =
    children.length > maxNameSize
      ? children.slice(0, maxNameSize - 3) + "..."
      : children;

  const handleClick = () => {
    trackEvent(
      `User clicked on entity details from activity log in control ${log.control_id}`
    );
    const params = new URLSearchParams(searchParams);
    params.set("entity", encodeURIComponent(entityId));
    setSearchParams(params.toString());
  };

  if (isComplexEntityType(entityType)) {
    return (
      <CustomTooltip
        title="View details"
        placement="top"
        arrow
        disableInteractive
      >
        <Box display="inline-block">
          <CustomLogTypography
            color={colors.primary_light}
            sx={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            {entityNameToDisplay}
          </CustomLogTypography>
        </Box>
      </CustomTooltip>
    );
  }
  return (
    <CustomTooltip
      title={children.length > maxNameSize ? children : ""}
      placement="top"
      arrow
      disableInteractive
    >
      <Box display="inline-block">
        <CustomLogTypography color={colors.text_secondary} fontWeight={500}>
          {entityNameToDisplay}
        </CustomLogTypography>
      </Box>
    </CustomTooltip>
  );
};
